import React from "react";
import chevronRight from "../../../assets/images/chevron-right.svg";
import tickIcon from "../../../assets/images/tick.svg";
import { useNavigate } from "react-router-dom";

interface ProfileCardProps {
  icon: string;
  title: string;
  completionPercentage: number;
  bgColor: string;
  navigateTo: string;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  icon,
  title,
  completionPercentage,
  bgColor,
  navigateTo,
}) => {
  const navigate = useNavigate();
  return (
    <section className="flex overflow-hidden flex-col justify-center p-4 mt-4 w-full bg-white rounded-3xl w-full shadow-[0px_0px_24px_rgba(0,0,0,0.02)]">
      <div
        className="flex gap-3 items-center w-full"
        onClick={() => navigate(navigateTo)}
      >
        <div className="flex flex-1 shrink gap-3 items-center self-stretch my-auto text-sm font-semibold leading-loose text-gray-800 basis-0">
          <div className="flex items-center justify-center w-[42px] h-[42px] rounded-2xl bg-[#F6EFFB]">
            <img
              loading="lazy"
              src={icon}
              alt={`${title} icon`}
              className="object-contain shrink-0 self-stretch my-auto aspect-square w-[22px] h-[22px]"
            />
          </div>
          <div className="flex items-center shrink gap-1 self-stretch my-auto text-left">
            {title}
            {completionPercentage === 100 && (
              <img
                loading="lazy"
                src={tickIcon}
                alt=""
                className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square ml-1"
              />
            )}
          </div>
        </div>
        <div className="flex gap-1 items-center self-stretch my-auto text-xs font-medium text-white">
          {completionPercentage !== 100 && (
            <div
              className={`overflow-hidden gap-2 self-stretch px-3 py-0.5 my-auto ${bgColor} rounded-3xl`}
            >
              {completionPercentage}% Completed
            </div>
          )}
          <img
            loading="lazy"
            src={chevronRight}
            alt=""
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
          />
        </div>
      </div>
    </section>
  );
};

export default ProfileCard;
